export default __webpack_public_path__ + "static/media/recruit02.323ec7b8.jpg";